export interface CommunityAcessTokenResponse {
  accessToken: string;
  expiresAt: string;
}

export enum ORGANIZATION_ROLE {
  ADMIN = "org:admin",
  MEMBER = "org:member",
}
